import { createSelector } from '@reduxjs/toolkit';
import { SOCIAL_FEATURES } from 'App/featuresFlags';
import { getAuthData } from 'domains/Auth/authSlice/authSelectors';

export const getSocialTags = createSelector(getAuthData, (data) => {
  const filteredTags = data?.tags?.filter((tag) =>
    SOCIAL_FEATURES.includes(tag),
  );
  return filteredTags?.join(',') ?? '';
});
